import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppDispatch } from "../store";
import { api } from '@/utils/api';

// Definimos el tipo de estado para `locations` 
interface Location {
  id: string;
  networkType: string;
  locationName: string;
  [key: string]: any;
}

interface LocationsState {
  fetching: boolean;
  array: Location[] | null;
  selectedLocation: string | null;
  current: Record<string, any>;
  error?: string;
}

// Estado inicial de `locations`
const initialState: LocationsState = {
  fetching: false,
  array: null,
  selectedLocation: null,
  current: {},
};

const locationsSlice = createSlice({
  name: "locations",
  initialState,
  reducers: {
    getLocations(state) {
      state.fetching = true;
    },
    getLocationsSuccess(state, action: PayloadAction<Location[]>) {
      state.fetching = false;
      state.array = action.payload;
    },
    getLocationsError(state, action: PayloadAction<string>) {
      state.fetching = false;
      state.error = action.payload;
    },
    setSelectedLocation(state, action: PayloadAction<string>) {
      state.selectedLocation = action.payload;
    },
  },
});

export const {
  getLocations,
  getLocationsSuccess,
  getLocationsError,
  setSelectedLocation,
} = locationsSlice.actions;
export default locationsSlice.reducer;

// Thunk para obtener las ubicaciones
export const getLocationsAction = (userId: string) => async (dispatch: AppDispatch) => {
  dispatch(getLocations());
  try {
    const res = await api.get(`${import.meta.env.VITE_APP_BASE_URL}/users/${userId}/locations`);
    dispatch(getLocationsSuccess(res.data));
  } catch (err: any) {
    console.error(err);
    dispatch(getLocationsError(err.response?.message || "Error desconocido"));
  }
};

// Thunk para establecer la ubicación seleccionada
export const setSelectedLocationThunk = (locationId: string) => (dispatch: AppDispatch) => {
  if (locationId) {
    dispatch(setSelectedLocation(locationId.toString()));
  }
};
